import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../utils/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      // One tinted pill recipe (bg-50 / text-700 / border-200); solid mid-tone fills fail AA at 12px.
      variant: {
        default: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100",
        secondary: "border-slate-200 bg-slate-100 text-slate-700 hover:bg-slate-200",
        destructive: "border-red-200 bg-red-50 text-red-700 hover:bg-red-100",
        outline: "text-foreground",
        success: "border-green-200 bg-green-50 text-green-700 hover:bg-green-100",
        warning: "border-yellow-200 bg-yellow-50 text-yellow-800 hover:bg-yellow-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
